import React, {useState} from 'react'
import {Modal, Tabs} from '@mantine/core'
import Button from './Button'
import '../styles/components/modal.css'
import Alert from './Alert'
import {apiRequest} from "../utils/api";

const LoginModal = ({opened, onClose, onSetUserId}) => {
    const [showVerification, setShowVerification] = useState(false)
    const [showPasswordInputs, setShowPasswordInputs] = useState(false)
    const [idAvailable, setIdAvailable] = useState(null);
    const [foundUserId, setFoundUserId] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [phone, setPhone] = useState('');
    const [codeSent, setCodeSent] = useState(false);
    const [verificationCode, setVerificationCode] = useState('');
    const [inputCode, setInputCode] = useState('');
    const [isVerified, setIsVerified] = useState(false);
    const [inputUserId, setInputUserId] = useState('');

    const [name, setName] = useState('');
    const [ssn, setSsn] = useState('');

    const [alertState, setAlertState] = useState({isOpen: false,message: ''});
    const showAlert = (message) => { setAlertState({  isOpen: true, message }); };
    const closeAlert = () => { setAlertState({  isOpen: false, message: '' });  };

    const handleVerificationClick = () => {
        setShowVerification(true)
    }

    const handleInputClick = () => {
        setShowPasswordInputs(true)
    }

    const handleSsnChange = (e) => {
        let value = e.target.value.replace(/[^0-9]/g, '');
        if (value.length > 6) value = value.slice(0, 6) + '-' + value.slice(6, 13);
        setSsn(value);
    };

    const handleGetUserId = async () => {
        if (!name || !ssn) {
            showAlert("이름과 주민번호를 입력해주세요.");
            return;
        }

        try {
            const res = await apiRequest('/getUserId', 'POST', {
                NAME: name,
                RNMCNO: ssn,
            });

            console.log("res", res);

            if (res.success && res.USERID) {
                setIdAvailable(true);
                setFoundUserId(res.USERID);
            } else {
                setIdAvailable(false);
            }
        } catch (error) {
            showAlert("서버 오류로 아이디를 찾을 수 없습니다.");
            setIdAvailable(false);
        }
    };

    const handleSendCode = async () => {
        if (!phone) {
            showAlert("전화번호를 입력해주세요.");
            return;
        }

        if (!inputUserId) {
            showAlert("아이디를 입력해주세요.");
            return;
        }

        if (!inputUserId) {
            showAlert("아이디를 입력해주세요.");
            return;
        }

        try {
            const res = await apiRequest('/sendSmsCode', 'POST', { PHONE:phone , USERID:inputUserId});
            if (res.success) {
                showAlert("인증번호가 전송되었습니다.");
                setCodeSent(true);
                setVerificationCode(res.code); // 실제 비교는 서버에서 해야 함
            } else {
                showAlert("인증번호 전송 실패");
            }
        } catch (err) {
            const match = err.message.match(/"message":"(.*?)"/);
            const extractedMessage = match ? match[1] : "알 수 없는 오류입니다.";
            alert(extractedMessage);
        }
    };

    const handleVerifyCode = async () => {
        try {
            const res = await apiRequest('/verifySmsCode', 'POST', {
                phone,
                code: inputCode,
            });
            if (res.success) {
                showAlert("인증 성공");
                setIsVerified(true)
                setShowPasswordInputs(true);
            } else {
                showAlert("인증번호가 일치하지 않습니다.");
            }
        } catch {
            showAlert("서버 오류");
        }
    };

    const handlePasswordReset = async () => {

        // 정규식: 영문 + 숫자 + 특수문자 포함, 8자 이상
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=])[A-Za-z\d!@#$%^&*()_\-+=]{8,}$/;

        if (!newPassword || !confirmPassword) {
            showAlert("비밀번호를 모두 입력해주세요.");
            return;
        }

        if (newPassword !== confirmPassword) {
            showAlert("비밀번호가 일치하지 않습니다.");
            return;
        }

        if (!passwordRegex.test(newPassword)) {
            showAlert("비밀번호는 영문, 숫자, 특수문자를 포함해 8자 이상이어야 합니다.");
            return;
        }

        try {
            const res = await apiRequest('/resetPassword', 'POST', {
                USERID: inputUserId,
                PASSWORD: newPassword,
            });

            if (res.success) {
                showAlert("비밀번호가 성공적으로 변경되었습니다.");
                onClose();
            } else {
                showAlert(res.message || "비밀번호 변경 실패");
            }
        } catch (err) {
            showAlert("서버 오류");
        }
    };

    const handleClose = () => {
        setShowVerification(false);
        setShowPasswordInputs(false);
        setIdAvailable(null);
        setFoundUserId('');
        setNewPassword('');
        setConfirmPassword('');
        setPhone('');
        setCodeSent(false);
        setVerificationCode('');
        setInputCode('');
        setIsVerified(false);
        setInputUserId('');
        setName('');
        setSsn('');
        onClose();
    };

    return (
        <>
        <Modal
            opened={opened}
            onClose={handleClose}
            size="md"
        >
            <Tabs color="green" defaultValue="findId">
                <Tabs.List>
                    <Tabs.Tab value="findId" className="gmarket-font" style={{width: '50%'}}>
                        아이디 찾기
                    </Tabs.Tab>
                    <Tabs.Tab value="findPassword" className="gmarket-font" style={{width: '50%'}}>
                        비밀번호 찾기
                    </Tabs.Tab>
                </Tabs.List>


                <Tabs.Panel value="findId" pt="lg">
                    <div className='login-input-wrapper'>
                        <input
                            className="gray-input gmarket-font"
                            placeholder="이름을 입력하세요"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <input
                            className="gray-input gmarket-font"
                            placeholder="주민번호를 입력하세요"
                            value={ssn}
                            onChange={handleSsnChange}
                            maxLength={14}
                        />
                        <Button
                                    className="gmarket-font"
                                    style={{height: '47px'}}
                                    onClick={handleGetUserId}
                                >
                                    확인
                                </Button>

                        {idAvailable === true && (
                            <>
                                <span style={{color: 'green'}}>귀하의 아이디는 {foundUserId} 입니다.</span>
                                <Button
                                    className="gmarket-font"
                                    style={{height: '47px', marginTop: '8px'}}
                                    onClick={() => {
                                        if (onSetUserId) onSetUserId(foundUserId);
                                        onClose();
                                    }}
                                >
                                    확인
                                </Button>
                            </>
                        )}
{idAvailable === false && (
    <div style={{
        display: 'flex', 
        marginBottom: '14px',
        backgroundColor: '#FFE1E1',
        color: 'red',
        padding: '8px',
        borderRadius: '5px',
        width: '100%',        
    }}>
        <span>일치하는 아이디가 없습니다.</span>
    </div>
)}
                        

                    </div>
                </Tabs.Panel>

                <Tabs.Panel value="findPassword" pt="lg">
                    <div className='login-input-wrapper'>
                        <input
                            className="gray-input gmarket-font"
                            placeholder="아이디를 입력하세요"
                            value={inputUserId}
                            onChange={(e) => setInputUserId(e.target.value)}
                        />
                        <div className='login-input-button-wrapper'>
                            <input
                                className="gray-input gmarket-font"
                                placeholder="전화번호를 입력하세요"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                            <Button className="gmarket-font" onClick={handleSendCode}>
                                인증
                            </Button>
                        </div>

                        {codeSent && (
                            <div className='login-input-button-wrapper'>
                                <input
                                    className="gray-input gmarket-font"
                                    placeholder="인증번호를 입력하세요"
                                    value={inputCode}
                                    onChange={(e) => setInputCode(e.target.value)}
                                />
                                <Button className="gmarket-font" onClick={handleVerifyCode}>
                                    입력
                                </Button>
                            </div>
                        )}

                        {showPasswordInputs && (
                            <>
                                <input
                                    type="password"
                                    className="gray-input gmarket-font"
                                    placeholder="새로운 비밀번호를 입력하세요"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <input
                                    type="password"
                                    className="gray-input gmarket-font"
                                    placeholder="새로운 비밀번호를 다시 입력하세요"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                <div className='login-input-wrapper'>
                                    <Button className="gmarket-font" style={{height: '47px'}} onClick={handlePasswordReset}>
                                        확인
                                    </Button>
                                </div>
                            </>
                        )}

                    </div>
                </Tabs.Panel>

            </Tabs>
        </Modal>
        <Alert
                isOpen={alertState.isOpen}
                message={alertState.message}
                onConfirm={closeAlert}
            />
        </>
    )
}

export default LoginModal